import {
  VisionLinkServiceMeterProp,
  ServiceMeterReadingNotFoundProp
} from '../../../types';
import { CatIconClock } from '@blocks-react/components/Icons/Clock';
import styles from '../../../VisionLink.module.scss';
import cx from 'classnames';
import { ServiceMeterReading } from './ServiceMeterReading';
import { ServiceMeterReadingNotFound } from './ServiceMeterReadingNotFound';

export const ServiceMeter = ({
  meterInfo,
  notFoundLabel,
  unitLabel,
  tooltipMessage
}: VisionLinkServiceMeterProp & ServiceMeterReadingNotFoundProp) => {
  return (
    <div
      className={cx(
        'd-flex align-items-center mb-1',
        styles['c-vision-link-card-text-wrap']
      )}
    >
      <CatIconClock className="u-color--MediumGray" />
      {meterInfo ? (
        <ServiceMeterReading
          meterInfo={meterInfo}
          unitLabel={unitLabel}
          tooltipMessage={tooltipMessage}
        />
      ) : (
        <ServiceMeterReadingNotFound notFoundLabel={notFoundLabel} />
      )}
    </div>
  );
};
